module.exports = __webpack_public_path__ + "fonts/Calibre-Thin.7d7d9bd8.woff2";